<div class="error-handling-container">
  <div class="error-handling">
    <div class="title-container">
      <h2>Oops!</h2>
    </div>
    <h3>{{errorTitle}}</h3>
    <p>{{errorDescription}}</p>
    <a [routerLink]="['/']" class="btn btn-primary">Go to Home</a>
  </div>
</div>
